// extracted by mini-css-extract-plugin
module.exports = {"container":"_1EeiIABd_stHQDbEYVbbhl","label":"_10Lgt1cjxD5LyUc7vW4Hfu"};